export const showList = () => {
	const theButton = document.querySelector('#list-view-all-button');
	const theTrigger = document.querySelectorAll('.standard-features-list');
	if (theButton) {
		theButton.onclick = function () {
			for (const x of theTrigger) {
				x.classList.toggle('show-list');
			}
		};
	}
};
